import { useI18n } from '@/lib/i18n'
import { cn } from '@/lib/utils'
import { formatMessageTime } from '@/social/message-time'
import type { SocialMessage } from '@/social/types'

import { RoomInviteCard } from './room-invite-card'

export function MessageRenderer({
  message,
  currentUserId,
  peerReadThroughSeq = 0,
}: {
  message: SocialMessage
  currentUserId: string
  peerReadThroughSeq?: number
}) {
  const { language, t } = useI18n()
  const own = message.senderUserId === currentUserId
  const read = own && (
    Boolean(message.readAt) || message.seq <= peerReadThroughSeq
  )
  return (
    <div
      className={cn('flex w-full', own ? 'justify-end' : 'justify-start')}
      data-message-seq={message.seq}
    >
      <div className={cn('max-w-[88%] space-y-1', own && 'items-end')}>
        <div
          className={cn(
            'rounded-2xl px-3 py-2 text-sm shadow-sm',
            own
              ? 'rounded-br-md bg-primary text-primary-foreground'
              : 'rounded-bl-md border bg-card text-card-foreground',
            message.type === 'room_invite' && 'bg-transparent p-0 shadow-none',
          )}
        >
          {message.type === 'text' ? (
            <p className="whitespace-pre-wrap break-words">{message.text}</p>
          ) : (
            <div className="space-y-2">
              {message.caption && (
                <p
                  className={cn(
                    'whitespace-pre-wrap break-words rounded-2xl px-3 py-2',
                    own
                      ? 'rounded-br-md bg-primary text-primary-foreground'
                      : 'rounded-bl-md border bg-card text-card-foreground',
                  )}
                >
                  {message.caption}
                </p>
              )}
              <RoomInviteCard room={message.room} />
            </div>
          )}
        </div>
        <p
          className={cn(
            'px-1 text-[10px] text-muted-foreground',
            own && 'text-right',
          )}
        >
          {formatMessageTime(message.createdAt, language)}
          {read && (
            <>
              {' '}
              <span>{t('social.conversation.read')}</span>
            </>
          )}
        </p>
      </div>
    </div>
  )
}
